import ReactDOM from 'react-dom/client';
import React from 'react';

export const initReact = (rootElement, Element) => {
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <Element />
      </React.StrictMode>
    );
  }
};
